import React from "react";
import { Textarea } from '@mantine/core';

const ProjectNotaCatatanDibatalkan = ({ stateData }) => {

    return (
        <React.Fragment>
            <Textarea
                value={stateData.data.value}
                readOnly={true}
                minRows={3}
                maxRows={4}

                styles={(tema) => ({
                    input: {
                        backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]
                    }
                })}

                label={stateData.data.label}
                placeholder={stateData.data.placeholder}
                error={stateData.data.error}
                description={stateData.data.description}
                withAsterisk={stateData.data.withAsterisk}
            />
        </React.Fragment>
    )
}

export default ProjectNotaCatatanDibatalkan;